import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { map, get, find, size, filter, includes, forEach, isEmpty, reduce, head } from 'lodash';
import AuditOrder from '../auditOrder';
import { Loading, If, Icon, Text, Row, FlexContainer, Button, HasPermissions } from '../../../../../../components/common';
import useOrderItemsQuery from '../../hooks/useOrderItemsQuery';
import { UPDATE_AUDIT_ORDER } from '../../../../../../components/graphql/updateAuditOrder';
import { useApollo } from '../../../../../../components/contexts/ApolloContext';
import styled, { css } from 'styled-components';

const FooterWrapper = styled(Row)`
    position: ${({ position }) => position};
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 15px;
    border-top: 1px solid #eaeaea;
    background-color: #ffffff;
    ${({ withZindex }) => withZindex && css`
        z-index: 2000;
    `}
`;

export const GroupOrdersTabContent = ({
    tabsOrderData,
    activeTab,
    onClose,
    userInfo
}) => {
    const client = useApollo();
    const [auditValuesPrimaryOrder, setAuditValuesPrimaryOrder] = useState({})
    const [auditInProcess, setAuditInProcess] = useState(false);
    const [auditValuesSecondaryOrder, setAuditValuesSecondaryOrder] = useState({})
    const [state, setState] = useState({
        wasSubmitted: false,
        primaryBipickingFormValues: {},
        secondaryBipickingFormValues: {},
        primaryBipickingValidationResults: {},
        secondaryBipickingValidationResults: {},
        currentStep: 0,
        hasntRejectedsPrimary: true,
        hasntRejectedsSecondary: true
    });

    const primaryOrderId = get(find(tabsOrderData, { key: 'primary' }), 'orderData.id', '');
    const secondaryOrderId = get(find(tabsOrderData, { key: 'secondary' }), 'orderData.id', '');
    
    const { loading: loadingPrimaryOrder, data: primaryOrderData } = useOrderItemsQuery({ id: primaryOrderId });
    const { loading: loadingSecundaryOrder, data: secondaryOrderData } = useOrderItemsQuery({ id: secondaryOrderId });

    const firstAudit = false;
    const weightError = false;

    const filterItems = (data) => {
        const { items, auditInfo } = data;
        const invalidItems = map(get(auditInfo, 'results.failed'), ({ productId }) => productId);

        return filter(items, (orderItem) => {
            return includes(invalidItems, get(orderItem, 'picking.id')) || includes(['ADDED_BY_CLIENT'], get(orderItem, 'status'));
        });
    }

    const onChangeAuditPrimaryOrder = ({ name, value }) => {
        setState({ ...state, wasSubmitted: false })

        if (get(auditValuesPrimaryOrder[name], 'value', 1) !== get(value, 'value', 1)) {
            auditValuesPrimaryOrder[name] = value;
            setAuditValuesPrimaryOrder(auditValuesPrimaryOrder);
        }
    }

    const onChangeAuditSecondaryOrder = ({ name, value }) => {
        setState({ ...state, wasSubmitted: false, })

        if (get(auditValuesSecondaryOrder[name], 'value', 1) !== get(value, 'value', 1)) {
            auditValuesSecondaryOrder[name] = value;
            setAuditValuesSecondaryOrder(auditValuesSecondaryOrder);
        }
    }

    const performAudit = async () => {
        setAuditInProcess(true);

        const auditsPrimary = map(state.primaryBipickingFormValues, (value, key) => ({
            productEan: key.split('-')[0],
            itemResponse: value === 1,
            userId: get(userInfo, 'email'),
            orderId: primaryOrderId
        }));

        const auditsSecondary = map(state.secondaryBipickingFormValues, (value, key) => ({
            productEan: key.split('-')[0],
            itemResponse: value === 1,
            userId: get(userInfo, 'email'),
            orderId: secondaryOrderId
        }));

        const payloadPrimary = { userId: get(userInfo, 'email'), orderId: primaryOrderId, audits: auditsPrimary };
        const payloadSecondary = { userId: get(userInfo, 'email'), orderId: secondaryOrderId, audits: auditsSecondary };

        const resultPrimary = await client.mutate({
            mutation: UPDATE_AUDIT_ORDER,
            variables: payloadPrimary
        });

        const resultSecondary = await client.mutate({
            mutation: UPDATE_AUDIT_ORDER,
            variables: payloadSecondary
        });

        console.log({ resultPrimary })
        console.log({ resultSecondary })

        setAuditInProcess(false);
        onClose();
    }

    const assignProductIdValueResolverPrimary = (productId) => {
        const value = filter(auditValuesPrimaryOrder, (_, index) => {
            return index === productId
        });
        return !isEmpty(value) ? head(value) : { label: 'Aprobar', value: 1 };
    }

    const assignProductIdValueResolverSecondary = (productId) => {
        const value = filter(auditValuesSecondaryOrder, (_, index) => {
            return index === productId
        });
        return !isEmpty(value) ? head(value) : { label: 'Aprobar', value: 1 };
    }

    const formOnSubmit = (primaryOrderData, secondaryOrderData) => {
        console.log({ primaryOrderData, secondaryOrderData })
        let valuesPrimary = {};
        let valuesSecondary = {};

        forEach(primaryOrderData, item => {
            const productId = get(item, 'picking.productId', get(item, 'productId'));

            if (productId) {
                valuesPrimary = { ...valuesPrimary, [productId]: assignProductIdValueResolverPrimary(productId) };
            }
        });

        forEach(secondaryOrderData, item => {
            const productId = get(item, 'picking.productId', get(item, 'productId'));

            if (productId) {
                valuesSecondary = { ...valuesSecondary, [productId]: assignProductIdValueResolverSecondary(productId) };
            }
        });

        setAuditValuesPrimaryOrder({});
        setAuditValuesSecondaryOrder({})
        setState({ ...state, hasntRejectedsSecondary: true })
        setState({ ...state, hasntRejectedsPrimary: true })

        const primaryBipickingValidationResults = reduce(valuesPrimary, ({ approved, rejected }, { value }, key) =>
            ({ approved: value ? [...approved, { [key]: value }] : approved,
                rejected: !value ? [...rejected, { [key]: value }] : rejected
            }), { approved: [], rejected: [] });

        const secondaryBipickingValidationResults = reduce(valuesSecondary, ({ approved, rejected }, { value }, key) =>
            ({ approved: value ? [...approved, { [key]: value }] : approved,
                rejected: !value ? [...rejected, { [key]: value }] : rejected
            }), { approved: [], rejected: [] });

        const submittedValuesPrimary = reduce(valuesPrimary, (acc, { value }, key) => (Object.assign(acc, { [key]: value })), {});
        const submittedValuesSecondary = reduce(valuesSecondary, (acc, { value }, key) => (Object.assign(acc, { [key]: value })), {});

        const hasntRejectedsPrimary = !size(get(primaryBipickingValidationResults, 'rejected'));
        const hasntRejectedsSecondary = !size(get(secondaryBipickingValidationResults, 'rejected'));
        console.log('setting config')
        setState({
            wasSubmitted: true,
            primaryBipickingFormValues: submittedValuesPrimary,
            secondaryBipickingFormValues: submittedValuesSecondary,
            secondaryBipickingValidationResults,
            primaryBipickingValidationResults,
            currentStep: (hasntRejectedsSecondary && hasntRejectedsPrimary) ? 0 : 1,
            hasntRejectedsPrimary,
            hasntRejectedsSecondary
        });
    }

    useEffect(() => {
        if (!state.wasSubmitted) return;

        if (state.hasntRejectedsPrimary && state.hasntRejectedsSecondary) {
            console.log('performAudit')
            performAudit();
        }
    }, [state.wasSubmitted]);

    const cancelRejectedOrdersAudit = () => {
        setState({
            ...state,
            currentStep: 0,
            primaryBipickingValidationResults: {},
            secondaryBipickingValidationResults: {},
            hasntRejectedsPrimary: true,
            hasntRejectedsSecondary: true
        })
    };

    const renderOrdersWithRejected = () => {
        const rejectedProductPrimary = state.primaryBipickingValidationResults;
        const rejectedProductSecondary = state.secondaryBipickingValidationResults;

        return <If condition={state.currentStep === 1}
            then={(
                <FlexContainer align='center' direction='column' justify='center' flex={1} >
                    <Icon name='alert-circle' size={80} color='#f38630' />
                    <FlexContainer mT={20} direction='column' align='center'>
                        <Text text={primaryOrderId} strong size={15} />
                        <Row justify='center'>
                            <Text text='Se rechazaron &nbsp;' />
                            <Text strong text={`${size(get(rejectedProductPrimary, 'rejected'))} productos`} />
                        </Row>
                    </FlexContainer>
                    <FlexContainer mT={30} direction='column' align='center'>
                        <Text text={secondaryOrderId} strong size={15} />
                        <Row justify='center'>
                            <Text text='Se rechazaron &nbsp;' />
                            <Text strong text={`${size(get(rejectedProductSecondary, 'rejected'))} productos`} />
                        </Row>
                    </FlexContainer>
                    <Row mT={30}>
                        <Text centered text='Enviaremos esta información al shopper para corregir' />
                    </Row>
                    <FooterWrapper
                        noWrap
                        noFlex
                        justify='flex-end'
                        position='absolute'
                    >
                        <Button link text='btn.action.cancel' style={{ width: 110 }} onClick={() => cancelRejectedOrdersAudit()} />
                        <Button
                            width={107}
                            disabled={auditInProcess}
                            loading={auditInProcess}
                            text='btn.action.confirm'
                            onClick={() => performAudit()}
                        />
                    </FooterWrapper>
                </FlexContainer>
            )}
        />
    }

    const renderConfirmAudit = () => {
        return <If condition={(state.currentStep === 0 && state.hasntRejectedsPrimary && state.hasntRejectedsSecondary)}
            then={(
                <FooterWrapper
                    noWrap
                    noFlex
                    justify='flex-end'
                    position='absolute'
                >
                    <Button onClick={onClose} secondary text='Cancelar' right={10} width={107} />
                    <HasPermissions to={['audit-monitor:perform-audit']}>
                        <Button
                            onClick={() => formOnSubmit(filterItems(primaryOrderData), filterItems(secondaryOrderData))}
                            disabled={auditInProcess || (firstAudit && !weightValidation && (weightError === 'true'))}
                            loading={auditInProcess}
                            text='Auditar'
                            width={107}
                        />
                    </HasPermissions>
                </FooterWrapper>
            )}
        />
    };

    return (<Loading loading={loadingPrimaryOrder && loadingSecundaryOrder}>
        <div style={{ position: 'relative' }}>
            {map(tabsOrderData, ({ key, orderData }) => {
                return <div key={key} style={{ display: activeTab === key ? 'block' : 'none' }} >
                    {(state.currentStep === 0 && state.hasntRejectedsPrimary && state.hasntRejectedsSecondary) && <>
                        <AuditOrder
                            weightError={false}
                            firstAudit={false}
                            data={key === 'primary'
                                ? primaryOrderData
                                : secondaryOrderData
                            }
                            onChangeAudits={key === 'primary'
                                ? onChangeAuditPrimaryOrder
                                : onChangeAuditSecondaryOrder
                            }
                            orderSelected={orderData}
                            orderId={get(orderData, 'id')}
                        />
                    </>}
                </div>
            })}
        </div>
        {renderConfirmAudit()}
        {renderOrdersWithRejected()}
    </Loading>);
};

GroupOrdersTabContent.propTypes = {
    tabs: PropTypes.array.isRequired,
    activeTab: PropTypes.string.isRequired,
    userId: PropTypes.string,
    onClose: PropTypes.func.isRequired
};